import { gate } from 'hub-http/gates';
export const EMAIL_AI_INSIGHTS_GATE = 'Email:MessagingInsights';
export const INSIGHTS_GA_RELEASE_GATE = gate('Email:InsightsGARelease');
export const BENCHMARK_INSIGHTS_GATE = gate('Insights:BenchmarkInsightsGate');